/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CameraRecorderChannels } from './CameraRecorderChannels';
import type { EngineLoadLimits } from './EngineLoadLimits';
import type { EngineSpeedLimits } from './EngineSpeedLimits';
import type { PedalLimits } from './PedalLimits';
import type { PrivateSwitch } from './PrivateSwitch';
import type { SensorSetup } from './SensorSetup';
import type { VehicleCommandType } from './VehicleCommandType';
import type { VehicleSetupIn } from './VehicleSetupIn';
/**
 * Vehicle setup
 */
export type VehicleSetup = {
    /**
     * Harsh acceleration tolerance (G)
     */
    acceleration_tolerance?: number;
    /**
     * Harsh braking tolerance (G)
     */
    braking_tolerance?: number;
    /**
     * Cameras available
     */
    cameras?: Array<CameraRecorderChannels> | null;
    /**
     * Nominal of CAN fuel tank, if not set, can_fuel not available (L)
     */
    can_fuel_volume?: number | null;
    /**
     * OBU commands enabled for this vehicle (derived from the OBU config)
     */
    commands?: Array<VehicleCommandType>;
    /**
     * Communication timeout (sec)
     */
    communication_timeout?: number | null;
    /**
     * Consumption norm
     */
    consumption_norm?: number;
    /**
     * Harsh cornering tolerance (G)
     */
    cornering_tolerance?: number;
    /**
     * Cruise control enabled
     */
    cruise_control?: boolean;
    /**
     * DDD download available
     */
    ddd?: boolean;
    engine_load_limits?: EngineLoadLimits;
    engine_speed_limits?: EngineSpeedLimits;
    ext_in_1?: VehicleSetupIn;
    ext_in_2?: VehicleSetupIn;
    ext_in_3?: VehicleSetupIn;
    ext_in_4?: VehicleSetupIn;
    ext_in_5?: VehicleSetupIn;
    /**
     * Has CAN flow meter
     */
    flow_meter?: boolean;
    fms_pto?: {
        /**
         * Name of the PTO
         */
        name: string | null;
    };
    /**
     * Fuel loss tolerance (L)
     */
    fuel_loss_tolerance?: number;
    /**
     * Number of fuel probes available, (if not set or zero, fuel not available)
     */
    fuel_probes?: number;
    /**
     * Nominal of each probe fuel tank (L)
     */
    fuel_volume?: {
        '1'?: number | null;
        '2'?: number | null;
        '3'?: number | null;
    } | null;
    /**
     * GPS available (if not set, GPS is available by default)
     */
    gps?: boolean;
    humidity?: Array<SensorSetup> | null;
    /**
     * Idle tolerance (sec)
     */
    idle_tolerance?: number;
    in_1?: VehicleSetupIn;
    in_2?: VehicleSetupIn;
    in_3?: VehicleSetupIn;
    in_4?: VehicleSetupIn;
    in_5?: VehicleSetupIn;
    /**
     * Path area width (meters)
     */
    path_area_width?: number;
    pedal_limits?: PedalLimits;
    private_switch?: PrivateSwitch;
    /**
     * Vehicle has real odometer available, ie.: DTCO/CAN
     */
    real_odometer?: boolean;
    /**
     * Refueling tolerance (L)
     */
    refueling_tolerance?: number;
    /**
     * Speed limit (km/h)
     */
    speed_limit?: number;
    /**
     * Temperature sensors
     */
    temperature?: Array<SensorSetup> | null;
    /**
     * Minimal trip duration (sec)
     */
    trip_duration?: number;
    /**
     * Uses odometer
     */
    uses_odometer?: boolean;
    /**
     * Voltage system, if not set = auto
     */
    voltage_system?: VehicleSetup.voltage_system;
};
export namespace VehicleSetup {
    /**
     * Voltage system, if not set = auto
     */
    export enum voltage_system {
        _12V = '12V',
        _24V = '24V',
        AUTO = 'auto',
    }
}

